import {IConsumptionDetailDTO, IMessage} from "@/interface"
import {convertCentsToEuros} from "@/mega-ui/helpers/function/convertCentsToEuros"
import {ConsumptionSummaryUnitEnum, TabsConsumptionDetailsEnum} from "@/enums"
import {
    convertBytesToStringMegabytes,
    convertKilobitsToStringGigabits,
    convertSecondsToStringHoursMinutesSecond
} from "@/mega-ui/helpers/function"

export class ConsumptionDetail {
    public id: number;
    public type: TabsConsumptionDetailsEnum | string | null;
    public message: IMessage;
    public amount: number;
    public consumption: string;
    public eventTime: Date | null;

    constructor(base?: Partial<ConsumptionDetail>) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IConsumptionDetailDTO) {
        return new ConsumptionDetail({
            id: dto.id,
            type: dto.service_cat ? TabsConsumptionDetailsEnum[dto.service_cat as TabsConsumptionDetailsEnum] : null,
            message: dto.messages,
            amount: dto.is_oob ? convertResourceUnit(dto.resource_impact, dto.resource_unit as ConsumptionSummaryUnitEnum) : 0,
            consumption: consumptionValue(dto),
            eventTime: dto.event_time ? new Date(dto.event_time) : null
        });
    }
}

export const consumptionValue = (dto: IConsumptionDetailDTO): string => {
    const key = dto.service_cat as TabsConsumptionDetailsEnum;
    const value = key === TabsConsumptionDetailsEnum.CALL && !dto.incoming && dto.resource_unit !== ConsumptionSummaryUnitEnum.CENT ? dto.resource_impact : dto.service_used

    // eslint-disable-next-line
    const consumptionValueSwitch: any = {
        [TabsConsumptionDetailsEnum.CALL]: convertResourceUnit(value, dto.service_unit as ConsumptionSummaryUnitEnum),
        [TabsConsumptionDetailsEnum.DATA]: convertResourceUnit(value, dto.service_unit as ConsumptionSummaryUnitEnum),
        [TabsConsumptionDetailsEnum.SMS]: `${value} SMS`
    }

    return TabsConsumptionDetailsEnum[key] ? consumptionValueSwitch[key] : "";
}

export const convertResourceUnit = (value = 0, unit: ConsumptionSummaryUnitEnum) => {
    // eslint-disable-next-line
    const consumptionUnitSwitch: any = {
        [ConsumptionSummaryUnitEnum.CENT]: convertCentsToEuros(value),
        [ConsumptionSummaryUnitEnum.CENTS]: convertCentsToEuros(value),
        [ConsumptionSummaryUnitEnum.SECOND]: convertSecondsToStringHoursMinutesSecond(value),
        [ConsumptionSummaryUnitEnum.SECONDS]: convertSecondsToStringHoursMinutesSecond(value),
        [ConsumptionSummaryUnitEnum.BYTE]: value > 10000000 ? convertKilobitsToStringGigabits(value) : convertBytesToStringMegabytes(value),
        [ConsumptionSummaryUnitEnum.BYTES]: value > 10000000 ? convertKilobitsToStringGigabits(value) : convertBytesToStringMegabytes(value)
    }

    return ConsumptionSummaryUnitEnum[unit] ? consumptionUnitSwitch[unit] : 0;
}